import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-image',
    template: `
    <div *ngIf="src">
      <div class="modal-header">
          <h4 class="modal-title">{{alt}}</h4>
          <button type="button" class="close" aria-label="Close" ngbAutofocus (click)="modal.close('modal closed');">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body">
        <img class="modal-image" [alt]="alt" [src]="src">
      </div>
    </div>
  `,
    styles: [`
      .modal-header {
          padding: 0.7rem !important;
      }
      .modal-header {
          color: #31708f;
          background-color: #d9edf7;
          border-bottom: 1px solid #bce8f1;
          border-radius: 6px 6px 0px 0px;
      }
      .modal-title {
        font-size:16px;
        font-weight: bold;
      }
      .modal-image {
        margin: auto; 
        display: block;
        width: 80%;
        max-width: 700px;
      }
    `]
})
export class ImageModalComponent implements OnInit {
    public alt: string = "";
    public src: string = "";

    constructor(public modal: NgbActiveModal) { }

    public ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/image-modal.component.ts